import Glide from "@glidejs/glide";

const $slider = document.getElementById("product-slide");
const sliderFULL = $slider?.querySelector(".product-slide__full .glide");
const sliderTHUMB = $slider?.querySelector(".product-slide_thumb--wrapper .glide");
const slidesFull = sliderFULL?.querySelectorAll(".glide__slide");

if ($slider) {
	const arrThumb = Array.from(slidesFull).map((value, key) => ({
		id: key,
		img: value.querySelector("[data-thumb-img]")?.dataset.thumbImg,
		video: !!value.querySelector("[data-thumb-video]")?.dataset.thumbVideo,
	}));

	arrThumb.forEach((value) => {
		const slideWrapper = sliderTHUMB.querySelector(".glide__slides");
		const newLi = document.createElement("li");
		newLi.classList.add("glide__slide", "slide-nav");
		newLi.innerHTML =		`<a href="${value.img}" data-fancybox="gallery-product-detail--thumb" class="product-slide_thumb--slide"
			data-index="${value.id}"
			${value.video && 'data-type="video"'}
		>
			<img src="${value.img}" alt="">
		</a>`;

		slideWrapper.appendChild(newLi);
	});

	const productSlideIndex = new Glide(sliderFULL, {
		perView: 1,
		autoplay: false,
	});

	const productSlideThumb = new Glide(sliderTHUMB, {
		perView: 4,
		focusAt: 0,
		swipeThreshold: false,
		dragThreshold: false,
		keyboard: false,
	});

	productSlideIndex.mount();
	productSlideThumb.mount();

	Array.from(document.querySelectorAll(".slide-nav")).forEach((el) => {
		el.addEventListener("click", function () {
			const target = this.querySelector("[data-index]");

			console.log(target.dataset.index);

			productSlideIndex.go(`=${target.dataset.index}`);
			productSlideThumb.go(`=${target.dataset.index}`);
		});
	});

	productSlideIndex.on("swipe.end", () => {
		productSlideThumb.go(`=${productSlideIndex.index}`);
	});

	productSlideIndex.on("move", () => {
		productSlideThumb.go(`=${productSlideIndex.index}`);
	});

	productSlideThumb.on("move", () => {
		productSlideIndex.go(`=${productSlideThumb.index}`);
	});
}
